import React from "react";
import Autosuggest from "react-autosuggest";
import theme from "../../styles/theme.css";


// Imagine you have a list of languages that you'd like to autosuggest.
// const languages = [
//   {
//     name: "C",
//     year: 1972,
//   },
//   {
//     name: "Elm",
//     year: 2012,
//   },
// ];
var languages = [];

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : languages.filter(
        (lang) => lang.name.toLowerCase().slice(0, inputLength) === inputValue
      );
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = (suggestion) => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion) => <div>{suggestion.name}</div>;

class PeopleBar extends React.Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: "",
      suggestions: [],
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  selectHandler = (newval) => {
    // console.log(newval.target.innerHTML);
    this.props.onSelect(newval.target.innerHTML);
  };

  render() {
    const { value, suggestions } = this.state;

    languages = this.props.users;
    // const { songs } = this.props;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: "Search for People",
      value,
      onChange: this.onChange,
    };

    // Finally, render it!
    return (
      <React.Fragment>
        <Autosuggest
          theme={{
            container: "react-autosuggest__container",
            input: "react-autosuggest__input",
            inputFocused: "react-autosuggest__input--focused",
            suggestionsContainerOpen:
              "react-autosuggest__suggestions-container--open",

            suggestionsList: "react-autosuggest__suggestions-list",
            suggestion: "react-autosuggest__suggestion",
            suggestionsContainer: "react-autosuggest__suggestions-container",
            suggestionHighlighted: "react-autosuggest__suggestion--highlighted",
          }}
          suggestions={suggestions}
          getSuggestionValue={getSuggestionValue}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
          onSuggestionSelected={this.selectHandler}
        />
       
      </React.Fragment>
    );
  }
}

export default PeopleBar;
